export default __webpack_public_path__ + "static/media/slovenia.e9cb6e9e.svg";